import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";

import { useCallback, useEffect, useRef, useState } from "react";

import API, { cancelAllRequests, createController } from "../../../../Network/API";
import { SITE_ID_FETCH_SUCCESS } from "../../../../Reducer/SiteIdSlice";
import AcsExportButton from "../../../../CustomHook/AcsExportButton";
import SiteAlarmNav from "../SiteAlarmNav";
import CountdownTimer from "../../../../Props/CountdownTimer";
import FilterSiteRmsAlarm from "./FilterSiteRmsAlarm";
import Agent from "../../../../Network/Agent";
import toast from "react-hot-toast";


export default function RmsSiteAlarm() {
    const [page, setPage] = useState(1);
    const [dateValue, setDateChange] = useState('')
    const [to_date, setToDateChange] = useState('')
    const [get_data, setData] = useState()
    const [loading, setLoading] = useState(false)
    const [alarm_type, setAlarmType] = useState('')
    const [acs_nav, setNavData] = useState([])
    const ddd = useParams();
    const dispatch = useDispatch()
    const observer = useRef();
    const [alarms, setAlarms] = useState([]);
    const rmsTypeController = useRef(null);
    const alarmController = useRef(null);

    const [loadingExport, setLoadingExport] = useState(false);

    const array_data = useRef({
        'page': 1,
        'site_id': ddd.id,
        'site_code': ddd.id,
        'tenant_id': "",
        'cluster': "",
        'zone': "",
        'alarm_type': "",
        'query': "",
        'start_date': "",
        'end_date': "",
        'filter_type': "",
        'query': "",
        'loadMore': false,
    });

    useEffect(() => {
         rmsTypeController.current?.abort();

    rmsTypeController.current = new AbortController();
    const signal = rmsTypeController.current.signal;
        Agent.RMS_ALARM.rms_alarm_type(dispatch, signal);
    }, []);

    useEffect(() => {

        dispatch(SITE_ID_FETCH_SUCCESS(ddd.id))
        if (page != 1) {
            array_data.current.page = page;
            array_data.current.loadMore = true;
        }
        fetchAlarm(array_data);

    }, [ddd.id, page]);

    const fetchAlarm = (array_data) => {
        setLoading(true);
        alarmController.current?.abort();

        alarmController.current = createController();
        const signal = alarmController.current.signal;
        Agent.SITE_DASHBOARD.site_rms_alarm_history(array_data.current, signal)
            .then((response) => {
                setLoading(false);
                if (array_data.current.loadMore && array_data.current.page > 1) {
                    setData(response.data.data)
                    setAlarms([...alarms, ...response.data.data.alarms])
                } else {
                    setData(response.data.data)
                    setAlarms(response.data.data.alarms)
                }

            }).catch((error) => {

            });
    }


    const clearSearch = () => {

        array_data.current.alarm_type = '';
        array_data.current.query = '';
        array_data.current.filter_type = '';
        array_data.current.tenant_id = '';
        array_data.current.start_date = '';
        array_data.current.end_date = '';
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        setPage(1);
        fetchAlarm(array_data);

    }

    const refreshFiler = () => {
        setPage(1);
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        fetchAlarm(array_data);
    }

    const callbackSearch = (searchData) => {

        console.log("Search Data in Parent:", searchData);
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        array_data.current.query = searchData?.query;
        array_data.current.site_code = searchData?.site_code;
        array_data.current.start_date = searchData?.start_date;
        array_data.current.end_date = searchData?.end_date;
        array_data.current.tenant_id = searchData?.tenant_id;
        array_data.current.cluster = searchData?.cluster;
        array_data.current.zone = searchData?.zone;
        array_data.current.filter_type = searchData?.filter_type;
        setPage(1);
        fetchAlarm(array_data);

    }

    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!get_data?.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && get_data?.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [get_data?.has_more_page]);

    function FormattedNumber(number = 0) {

        const formatted = number.toLocaleString(); // or Intl.NumberFormat().format(number)

        return formatted;
    }

    const copyToClipboard = (s_data) => {
        // Manually construct the text with line breaks between fields
        const formattedText = `
              Site ID: ${s_data.site_id}
              Operator Site ID: ${s_data.easi_site_id}
              Tenant: ${s_data.tenant_name}
              Alarm Name: ${s_data.name}
              Alarm Time: ${s_data.alarm_start}
            `;

        // Create a temporary textarea element to copy the formatted text
        const textArea = document.createElement('textarea');
        textArea.value = formattedText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        alert('Copied to clipboard!');
    };

    
  async function downloadAlarmReport(params) {
    try {
      setLoadingExport(true)
      if (array_data.current.start_date == '' && array_data.current.end_date == '') {
        toast.error('Please select date')
        setLoadingExport(false)
        return false;
      }
      const response = await API.get(`/v1/oauth/export_rms_alarm?query=${encodeURIComponent(alarm_type)}&site_id=${array_data?.current.site_code}&start_date=${array_data.current.start_date}&end_date=${array_data.current.end_date}&tenant_id=${array_data?.current.tenant_id}&alarm_type=${array_data?.current.alarm_type}&filter_type=${array_data?.current.filter_type}&cluster=${array_data?.current.cluster}&zone=${array_data?.current.zone}`, {
        params,
        responseType: 'blob',
      });
      // Extract filename from Content-Disposition header or set a default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'rms_active_alarms.xlsx'; // Default filename

      if (contentDisposition) {
        const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
        if (matches && matches[2]) {
          filename = matches[2];
        }
      }

      // Create download link and trigger download
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(new Blob([response.data]));
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up the download link to avoid memory leaks
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error('Error exporting file:', error);
    } finally {
      setLoadingExport(false);
    }
  }


    return (
        <>
            <div className="row">
                <SiteAlarmNav id={2} site_id={ddd.id} />
            </div>
            <div className="row ms-1 me-1 mb-1">
                <div class="align-items-center d-flex">
                    <b class="main-card-title mb-0 flex-grow-1"></b>
                    <div class="flex-shrink-0">
                        <div class="">
                            <div class="input-group input-group-sm">
                                <FilterSiteRmsAlarm callbackSearch={callbackSearch} />

                                <a href="#" onClick={() => refreshFiler()} class="input-group-text bg-warning"><i className="fa-light fa-sync me-1" /> Reload</a>
                                <button onClick={() => downloadAlarmReport()} className="btn btn-sm btn-success"><i className="fa-light fa-file-export me-1" /> Export</button>
                               <button onClick={() => clearSearch()} class="btn btn-danger"> <i className="fa-light fa-eraser me-1" /> Clear</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row me-1 ms-1">
                <div className="table-responsive custom-table-responsive scroll-side-nav">
                    {loading && <div className="text-center">Loading......</div>}
                    <table className="table custom-table text-center ">
                        <tbody>

                            {alarms?.length > 0 && alarms?.map((alarm, index) => (

                                <>
                                    <tr className="bg-white" ref={index === alarms?.length - 1 ? lastElementRef : undefined}>
                                        <td>
                                            <i onClick={() => copyToClipboard(alarm)} className="fa fa-copy text-success" style={{ fontSize: '20px', cursor: 'pointer' }} />

                                        </td>
                                        <td width="7%">
                                            <div className="signal-bars mt1 sizing-box good four-bars">
                                                <span>
                                                    <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                                </span>
                                                <div className={`first-bar bar ${alarm.network >= 1 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`second-bar bar ${alarm.network >= 2 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`third-bar bar ${alarm.network >= 3 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`fourth-bar bar ${alarm.network >= 4 ? '' : 'null-color'}`}>
                                                </div>
                                                <div className={`fifth-bar bar ${alarm.network >= 5 ? '' : 'null-color'}`}>
                                                </div>
                                            </div>
                                        </td>
                                        <td width="7%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                                            <p className="tr-header">Cluster</p>
                                            <p className="tr-header-sub ">{alarm.cluster_name}
                                            </p>
                                        </td>
                                        <td width="7%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                                            <p className="tr-header">Zone</p>
                                            <p className="tr-header-sub ">{alarm.zone_name}
                                            </p>
                                        </td>
                                        <td width="8%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                                            <p className="tr-header">SITE ID</p>
                                            <p className="tr-header-sub fw-bold"><Link to={`/site/${alarm.site_id}`}>{alarm.site_id}</Link>
                                            </p>
                                        </td>
                                        <td width="12%">
                                            <p className="tr-header">Tenant</p>
                                            <p className="tr-header-sub">{alarm.tenant_name}</p>
                                        </td>
                                        <td width="10%" >
                                            <p className="tr-header">Operator Site</p>
                                            <p className="tr-header-sub fw-bold"><Link className={`${alarm?.tenant_name == 'Robi' ? 'text-danger' : (alarm?.tenant_name == 'GP' ? 'text-info' : 'text-bl')}`} to={`/site/${alarm.site_id}`}>{alarm.tenant_site_id}</Link></p>
                                        </td>
                                        <td width="25%">
                                            <p className="tr-header">Alarm Name</p>
                                            <p className="tr-header-sub">
                                                {alarm.name}
                                            </p>
                                        </td>
                                        <td width="15%">
                                            <p className="tr-header">Alarm Start</p>
                                            <p className="tr-header-date">
                                                {alarm.alarm_start}

                                            </p>
                                        </td>
                                        <td width="15%">
                                            <p className="tr-header">Alarm End</p>
                                            <p className="tr-header-date">
                                                {alarm.alarm_end ?? '--'}
                                            </p>
                                        </td>
                                        <td width="20%" className="elisp_time">
                                            <p className="tr-header">Elapsed Time</p>
                                            <p className="tr-header-sub elisp_time">
                                                {alarm.alarm_end != null ?
                                                    <span className="elisp_time">{alarm.total_elaspsed}</span>
                                                    :
                                                    <CountdownTimer targetDate={alarm.start} />
                                                }


                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="spacer"><td colSpan={100} /></tr>
                                </>

                            ))}
                        </tbody>
                    </table>


                    {alarms?.length <= 0 ? <div className="text-muted text-center py-3 fs-5">
                        <i className="fas fa-bell-slash me-1" />
                        No alarm records found for this site.
                    </div> : ''}

                </div>
                <p className="p-0 m-0 fs-12">Current Display 1 - {alarms?.length} Record(s), {FormattedNumber(get_data?.total_page)} Record(s) Totally</p>

            </div>


        </>
    )
}